// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: YQh8OvWodbkq
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreditorPayoutModal.module.css"; // plasmic-import: YQh8OvWodbkq/css

createPlasmicElementProxy;

export const PlasmicCreditorPayoutModal__VariantProps = new Array();

export const PlasmicCreditorPayoutModal__ArgProps = new Array();

const $$ = {};

function PlasmicCreditorPayoutModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "percentage.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ``
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <div
      data-plasmic-name={"center"}
      data-plasmic-override={overrides.center}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.center
      )}
    >
      <div
        data-plasmic-name={"title8"}
        data-plasmic-override={overrides.title8}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.title8
        )}
      >
        {"Pricing Type"}
      </div>
      <div
        data-plasmic-name={"selectTypeStack"}
        data-plasmic-override={overrides.selectTypeStack}
        className={classNames(projectcss.all, sty.selectTypeStack)}
      />

      <div
        data-plasmic-name={"title9"}
        data-plasmic-override={overrides.title9}
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.title9
        )}
      >
        {"Percentage"}
      </div>
      <input
        data-plasmic-name={"percentage"}
        data-plasmic-override={overrides.percentage}
        className={classNames(projectcss.all, projectcss.input, sty.percentage)}
        onChange={async (...eventArgs) => {
          (e => {
            generateStateOnChangeProp($state, ["percentage", "value"])(
              e.target.value
            );
          }).apply(null, eventArgs);
        }}
        placeholder={``}
        ref={ref => {
          $refs["percentage"] = ref;
        }}
        size={1}
        type={"number"}
        value={generateStateValueProp($state, ["percentage", "value"]) ?? ""}
      />

      <div
        data-plasmic-name={"setPrice"}
        data-plasmic-override={overrides.setPrice}
        className={classNames(projectcss.all, sty.setPrice)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text
          )}
        >
          {hasVariant(globalVariants, "screen", "medium")
            ? "Submit"
            : "Set Price"}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  center: [
    "center",
    "title8",
    "selectTypeStack",
    "title9",
    "percentage",
    "setPrice",
    "text"
  ],

  title8: ["title8"],
  selectTypeStack: ["selectTypeStack"],
  title9: ["title9"],
  percentage: ["percentage"],
  setPrice: ["setPrice", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreditorPayoutModal__ArgProps,
          internalVariantPropNames: PlasmicCreditorPayoutModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreditorPayoutModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "center") {
    func.displayName = "PlasmicCreditorPayoutModal";
  } else {
    func.displayName = `PlasmicCreditorPayoutModal.${nodeName}`;
  }
  return func;
}

export const PlasmicCreditorPayoutModal = Object.assign(
  // Top-level PlasmicCreditorPayoutModal renders the root element
  makeNodeComponent("center"),
  {
    // Helper components rendering sub-elements
    title8: makeNodeComponent("title8"),
    selectTypeStack: makeNodeComponent("selectTypeStack"),
    title9: makeNodeComponent("title9"),
    percentage: makeNodeComponent("percentage"),
    setPrice: makeNodeComponent("setPrice"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicCreditorPayoutModal
    internalVariantProps: PlasmicCreditorPayoutModal__VariantProps,
    internalArgProps: PlasmicCreditorPayoutModal__ArgProps
  }
);

export default PlasmicCreditorPayoutModal;
/* prettier-ignore-end */
